module.exports = __webpack_public_path__ + "static/img/asan-dc1.9810dad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/asan-dc1.jpg
// module id = QWc2
// module chunks = 0